module.exports = __webpack_public_path__ + "img/layoutBargr.ed50c117.png";